module.exports = __webpack_public_path__ + "static/media/switch.0151f998.svg";